import React from "react";
import CTable from "components/common/Table";
import { withRouter } from "react-router";
import IconButton from "components/common/IconButton";
import ImageComponent from "components/common/Image";

const ChargingNetworkWiseList = ({
  loading,
  onDeleteClick,
  data,
  handleDeleteNetworkClick,
}) => {
  const columns = [
    {
      field: "name",
      headerName: "Charging network",
      valueGetter: (v, d) => {
        return <>{<>{d.network?.name}</>}</>;
      },
    },
    {
      field: "city",
      headerName: "City",
    },
    {
      field: "coupon_code",
      headerName: "Coupon code",
    },
    {
      field: "title",
      headerName: "Coupon title",
    },
    {
      field: "sub_title",
      headerName: "Coupon sub_title",
    },
    {
      field: "description",
      headerName: "Coupon description",
    },
    {
      field: "type",
      headerName: "Coupon Type",
    },
    {
      field: "start_date",
      headerName: "Start date",
    },
    {
      field: "expiry_date",
      headerName: "End date",
    },
    {
      field: "coupon_status",
      headerName: "Status",
    },

    {
      field: "action",
      headerName: "Action",
      valueGetter: (v, d) => {
        return (
          <>
            {
              <>
                <IconButton
                  aria-label="delete"
                  onClick={() => onDeleteClick()}
                  sx={{
                    color: "green",
                  }}
                >
                  <ImageComponent
                    src="delete-icon.svg"
                    onClick={() => handleDeleteNetworkClick(d.id)}
                  />
                </IconButton>
              </>
            }
          </>
        );
      },
    },
  ];

  return (
    <CTable
      columns={columns}
      data={data}
      isLoading={loading}
      pagination={true}
      localPagination={true}
      page={0}
      rowsPerPage={5}
    ></CTable>
  );
};

export default withRouter(ChargingNetworkWiseList);
